import './Editor.scss';
import Tiptap from './TipTap.js';

const Editor = (props) => {
	return (
		<div className="editor">
			<Tiptap
				content={props.content}
				callback={props.contentCallback}
			/>
		</div>
	)
}

export default Editor;